export const currencyDefaults = {
  code: 'GBP',
  symbol: '£',
};
